import { Stack, Box, Button } from "@chakra-ui/react";
import React, { useState } from "react";
import Calculationtable from "./Calculationtable";
import Gpatable from "./Gpatable";

export default function Example() {
    const [show, setShow] = useState(false)
    return (
        <Box>
            <Box display="flex" justifyContent="center" >
                <Button onClick={()=>setShow(!show)}  p="5" my="20" >
                Голч яаж бодогддог вэ?
                </Button>
            </Box>
            {
                show?
            <Stack direction={['column', 'row']} spacing='24px' maxW="920px" m="auto">
                <Gpatable />
                <Calculationtable />
            </Stack>
            :null
            }
        </Box>
    )
  }